import { connect } from 'react-redux';
import * as RX from 'reactxp';
import { Window } from '../../../reducers/window';
import { md } from '../../../utils/breakpoints';
import t from '../../../utils/i18n';
import { mapStateToProps } from '../../../utils/mapper';
import { colors } from '../../../utils/styles';

import ExternalLink from '../../external_link';

import { Link } from '../../../modules/routing';

interface MenuDropdownProps {
  dispatch: ({ type }: { type: string, [key: string]: any}) => void;
  window: Window;
  menu: { right?: number, menuItems?: any; };
  test?: boolean;
};

const styles = {
  button: RX.Styles.createButtonStyle({
    marginBottom: 8,
    minHeight: 40,
    padding: 0,
    position: 'absolute',
    right: 16,
    top: 16,
  }),
  close: RX.Styles.createTextStyle({
    fontSize: 20,
    fontWeight: 'bold',
  }),
  menuDropdown: RX.Styles.createViewStyle({
    backgroundColor: colors.background,
    justifyContent: 'center',
    padding: 16,
    position: 'absolute',
  }),
  wrapper: RX.Styles.createViewStyle({
    alignItems: 'center',
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
    top: 0,
  }),

};

export class MenuDropdown extends RX.Component<MenuDropdownProps, RX.CommonProps & MenuDropdownProps> {
  constructor(props: MenuDropdownProps) {
    super(props);
  }

  public render() {
    const { window: { width, height}, test, menu: { menuItems, right }, dispatch } = this.props;

    return (
      menuItems ?
      <RX.View
        style={[styles.wrapper, { width, height }]}
        onPress={() => dispatch({ type: 'CLOSE_MENU_ITEMS' })}
      >
        <RX.View
          style={[
          styles.menuDropdown,
          {
            borderBottomWidth: 1,
            borderColor: colors.lightGrey,
            borderLeftWidth: 1,
            borderRightWidth: 1,
            borderTopWidth: 0,
            left: right,
            top: 102,
            width: 300,
          }]}
        >
          {menuItems.map(({ title, url, external }) => <RX.View
            key={title}
            style={[
              width < md
              ? { width }
              : {
                backgroundColor: colors.background,
                justifyContent: 'center',
                minWidth : 10,
              }
            ]}
          >
            { /*external ?
              <ExternalLink isMenu text={title} destination={url} locText={t('external.scheduling')} /> :
              !test ? <Link
                onPress={() => { dispatch({ type: 'CLOSE_MENU_ITEMS' }); }}
                style={
                  {
                    color: colors.menuBlue,
                    fontSize: 18,
                    fontWeight: '400',
                    marginBottom: 0,
                    minHeight: 40,
                    paddingBottom: 8,
                    paddingTop: 8,
                    textDecoration: 'none',
                  }
                }
                to={url}
              >
                {title}
              </Link> : */ <a
                onClick={() => { dispatch({ type: 'CLOSE_MENU_ITEMS' }); }} target={external ? '_blank' : '_self'}
                style={
                  {
                    color: colors.menuBlue,
                    fontSize: 18,
                    marginBottom: 0,
                    minHeight: 40,
                    paddingBottom: 8,
                    paddingTop: 8,
                    textDecoration: 'none',
                  }
                }
                href={url}
              >
                {title}
              </a>
            }
          </RX.View>
          )}

        </RX.View>
      </RX.View> : null
    );
  }
}

export default connect(mapStateToProps)(MenuDropdown);



// WEBPACK FOOTER //
// ./src/components/menu/menu_dropdown/index.tsx